import React, { useEffect, useState } from 'react'
import { ReactComponent as Logo } from "../../assets/MMT_Logo.svg";
import { ReactComponent as LogoSmall } from "../../assets/Logo_small.svg";
import { ReactComponent as HamburgerIcon } from "../../assets/Hamburger.svg";
import LanguageDropdown from "../header/LangaugeDropdown";
import SmallButton from "../header/SmallButton";
import Search from './Search';
import { useTranslation } from 'react-i18next';
import i18n from '../../locales/i18n';
import AuthButton from './AuthButton';
import { useAppContext } from '../../AppContext';
import { useNavigate } from 'react-router-dom';
import { CartService } from '../../services/CartService';

interface HeaderTopProps {
  search: string;
  setSearch: (search: string) => void;
  onSearch: () => void;
  handleLoginClick: () => void;
  handleRegisterClick: () => void;
  setIsMenuOpen: (isOpen: boolean) => void;
  isMenuOpen: boolean;
  runAnimation: boolean;
  setRunAnimation: (run: boolean) => void;
}

function HeaderTop({ search, setSearch, onSearch, handleLoginClick, handleRegisterClick, setIsMenuOpen, isMenuOpen, runAnimation, setRunAnimation }: HeaderTopProps) {
  const { t } = useTranslation();
  const { user, role, cartCount, setCartCount } = useAppContext();
  const [isRTL, setIsRTL] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleLanguageChange = () => {
      setIsRTL(i18n.language === "ar");
    };

    i18n.on("languageChanged", handleLanguageChange);
    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, []);

  useEffect(() => {
    const fetchCartCount = async () => {
      if (user) {
        try {
          const result = await CartService.GetCart();
          setCartCount(result.items.length);
        } catch (error) {
           
        }
      }
    };

    fetchCartCount();
  }, [user, setCartCount]);

  const handleMenuClick = () => {
    setRunAnimation(!runAnimation);
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="w-full h-[110px] bg-white flex items-center lg:px-10 xl:px-28 md:px-10 px-5 justify-between border-b border-gray lg:border-0 xl:border-0">
      <div className="lg:w-1/5 xl:w-1/4 hidden md:flex">
        <div className='w-fit cursor-pointer' onClick={() => navigate('/')} >
          <Logo />
        </div>
      </div>
      <div className="lg:w-1/5 xl:w-1/4 flex md:hidden cursor-pointer">
        <div className='w-fit' onClick={() => navigate('/')} >
          <LogoSmall />
        </div>
      </div>
      <div className="flex items-center lg:w-4/5 xl:w-3/4 gap-[20px]">
        <div className="w-full hidden lg:block ">
          <Search
            search={search}
            setSearch={setSearch}
            onSearch={onSearch}
          />
        </div>
        {role !== "publisher" && user && (
          <div className=" relative">
            <SmallButton type="cart" />
            {cartCount > 0 && (
              <div className=" absolute top-[-10px] right-[-10px] w-6 sm:w-7 h-6 sm:h-7 rounded-full bg-primary_500 flex items-center justify-center">
                <p className='text-white font-semibold text-sm'>{cartCount}</p>
              </div>
            )}
          </div>
        )}
        {user && (
          <div
            className={`hidden md:block`}
          >
            <SmallButton type="profile" />
          </div>
        )}
        <div className={` hidden lg:block`}>
          <LanguageDropdown />
        </div>
        {!user && (
          <>
            <div className={` hidden lg:flex`}>
              <AuthButton
                title={t("navigation.login")}
                onClick={handleLoginClick}
              />
            </div>
            <div className="hidden lg:flex">
              <AuthButton
                title={t("navigation.register")}
                onClick={handleRegisterClick}
              />
            </div>
          </>
        )}

        <button
          className="block lg:hidden"
          onClick={handleMenuClick}
        >
          <HamburgerIcon />
        </button>
      </div>
    </div>
  )
}

export default HeaderTop
